import { types } from 'mobx-state-tree';
/**
 * #stateModel DialogQueueSessionMixin
 */
export function DialogQueueSessionMixin() {
    return types
        .model('DialogQueueSessionMixin', {})
        .volatile(() => ({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        queueOfDialogs: [],
    }))
        .views(self => ({
        /**
         * #getter
         */
        get DialogComponent() {
            var _a;
            return (_a = self.queueOfDialogs[0]) === null || _a === void 0 ? void 0 : _a[0];
        },
        /**
         * #getter
         */
        get DialogProps() {
            var _a;
            return (_a = self.queueOfDialogs[0]) === null || _a === void 0 ? void 0 : _a[1];
        },
    }))
        .actions(self => ({
        /**
         * #action
         */
        removeActiveDialog() {
            self.queueOfDialogs = self.queueOfDialogs.slice(1);
        },
        /**
         * #action
         */
        queueDialog(cb) {
            const [component, props] = cb(() => {
                this.removeActiveDialog();
            });
            self.queueOfDialogs = [...self.queueOfDialogs, [component, props]];
        },
    }));
}
//# sourceMappingURL=DialogQueue.js.map